import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex h-screen w-full" }
const _hoisted_2 = { class: "template-main-sidebar bg-primary flex h-full flex-col overflow-y-auto sm:w-60 md:fixed" }
const _hoisted_3 = { class: "flex flex-1 flex-col overflow-y-auto" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "template-main-content w-full md:pl-60" }
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = { class: "flex w-full items-center" }
const _hoisted_8 = { class: "grid w-full grid-cols-2 gap-4 md:grid-cols-5" }
const _hoisted_9 = { class: "flex items-center pl-2 text-gray-50" }

import { ref, computed, onMounted, type Ref, ComputedRef } from 'vue';
import { JSX } from 'vue/jsx-runtime';

import { useAuthStore, useFilterStore, useUiStore } from '@/stores';
import {
    TemplateHeader,
    TemplateSidebar,
    TemplateNavigation,
    TemplateProfile,
} from '@/views/templates/components';

import { LevelModel, NavigationItem, CompanyModel } from '@/types';
import { SelectOptionsService } from '@/services';
import { toastServiceError } from '@/services/core/notification';
import { SelectOptionsServiceGetLevelsResult } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTemplate',
  props: {
    navigationItems: {},
    headerActions: { type: Function },
    title: {},
    routerKey: {}
  },
  setup(__props: any) {



const uiStore = useUiStore();
const filterStore = useFilterStore();

const levelOptions: Ref<SelectOptionsServiceGetLevelsResult[]> = ref([]);

const logoPath = computed(() => {
    const authStore = useAuthStore();
    const company: ComputedRef<CompanyModel | undefined> = computed(() => authStore.userCompany);
    return company.value?.templateLogo || '/img/logo-mob.png';
});

const loading = computed(() => uiStore.isLoading);

const isLevelLocked = computed(() => uiStore.isLevelLocked);

const levelFilter = computed<LevelModel | null>({
    get: () => filterStore.level,
    set: (level: LevelModel) => filterStore.setLevel(level),
});

const headerClass = computed(() => {
    if (process.env.NODE_ENV === 'production') return 'bg-slate-100';
    if (process.env.NODE_ENV === 'development') return 'bg-teal-700';
    return 'bg-gray-700';
});

const fetchLevels = async () => {
    try {
        const { data } = await SelectOptionsService.getLevels();
        levelOptions.value = data;
    } catch (err) {
        toastServiceError(err);
    }
};

onMounted(async () => {
    await fetchLevels();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_UiMultiselect = _resolveComponent("UiMultiselect")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_UiLoadingDialog = _resolveComponent("UiLoadingDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(TemplateSidebar), null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, { to: { name: 'Home' } }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "mb-8 ml-4 mt-3 h-12",
                  src: logoPath.value
                }, null, 8, _hoisted_4)
              ]),
              _: 1
            }),
            _createVNode(_unref(TemplateNavigation), { items: _ctx.navigationItems }, null, 8, ["items"])
          ]),
          _createVNode(_unref(TemplateProfile))
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass([headerClass.value, "sticky top-0 z-30 flex items-center p-2 shadow sm:px-4 sm:py-2"])
        }, [
          _createElementVNode("header", _hoisted_7, [
            _createVNode(_unref(TemplateHeader), null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_UiMultiselect, {
                    name: "template_level",
                    label: "name",
                    "value-prop": "id",
                    modelValue: levelFilter.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((levelFilter).value = $event)),
                    options: levelOptions.value,
                    class: "col-span-2",
                    disabled: isLevelLocked.value
                  }, null, 8, ["modelValue", "options", "disabled"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _renderSlot(_ctx.$slots, "headerActions")
                ])
              ]),
              _: 3
            })
          ])
        ], 2),
        _createElementVNode("main", null, [
          (_openBlock(), _createBlock(_component_router_view, { key: _ctx.routerKey }))
        ])
      ]),
      _createVNode(_component_UiLoadingDialog, {
        show: loading.value,
        text: _ctx.$t('ui-loading-dialog-text')
      }, null, 8, ["show", "text"])
    ])
  ]))
}
}

})